import { FinderOrigin } from '../types';

const EARTH_RADIUS_KM = 6371;

export const isValidCoordinate = (latitude?: number | null, longitude?: number | null) =>
  latitude != null &&
  longitude != null &&
  Number.isFinite(latitude) &&
  Number.isFinite(longitude) &&
  Math.abs(latitude) <= 90 &&
  Math.abs(longitude) <= 180 &&
  !(latitude === 0 && longitude === 0);

/** Great-circle (haversine) distance */
export const getDistanceKm = (lat1: number, lng1: number, lat2: number, lng2: number) => {
  const toRad = (deg: number) => (deg * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(h));
};

export const isSameLocation = (a?: FinderOrigin | null, b?: FinderOrigin | null) =>
  !!a && !!b && a.latitude === b.latitude && a.longitude === b.longitude;
